import { Component } from '@angular/core';

declare var $:any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent{}

export enum SpotAction {
    vacateUntil,
    vacate,
    cancelVacation,
    none
}

export class Spot {
	id: string;
	code: string;
	departmentName: string;
	free: boolean;
	assigned: boolean;
	permanent: boolean;
	name: string;
	free_until: string;
	personA: string;
	personP: string;
	action: SpotAction;
}

export class Person {
	id: string;
	department: string;
	first_name: string;
	last_name: string;
	photo: string;
	spot: Spot;
}

export const APIhost: string = "https://sps.borko-web.com/"; //"http://localhost/sps/";


// WEBPACK FOOTER //
// /Users/boriskolozsi/Documents/WWW/sps-web/src/app/app.component.ts